<script setup lang="ts">
import TableSortBtn from '@/components/btns/TableSortBtn.vue';

import tableStyles from '@/styles/table.module.scss';

export interface Props {
  actives: Record<string, boolean>;
  ascs: Record<string, boolean>;
  handleSort: (titleName: string, event: Event) => void;
  headerItemValue: string;
  isNotSortable?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isNotSortable: false,
});
</script>

<template>
  <th
    v-if="props.isNotSortable"
    :class="$style.sortThTableCell"
    data-testid="sortThTableCell"
  >
    <slot></slot>
  </th>
  <th
    v-else
    :class="[$style.sortThTableCell, $style.sortTh]"
    data-testid="sortThTableCell"
    @click="handleSort(props.headerItemValue, $event)"
  >
    <slot></slot>
    <TableSortBtn
      :class="tableStyles.sortBtn"
      :is-active="props.actives[props.headerItemValue]"
      :is-asc="props.ascs[props.headerItemValue]"
      @click="handleSort(props.headerItemValue, $event)"
    />
  </th>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';


th.sortTh {
  cursor: pointer;
  user-select: none;
}
</style>
